// Path: src/components/aols/aOLSLMasset/aOLSLMasset.tsx
// Fixed body text color by using a styled-component to ensure style application over Ant Design defaults.

import React, { useState, useEffect, useCallback, useRef } from "react";
import { Button, Layout, Typography } from "antd"; 
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components"; // Added import for styled-components
import { withFirebase } from "../../dev/Firebase/Firebase"; 
import { publicImages } from "../../auth/constants/PublicImg";
import { Helmet } from "react-helmet-async";
import logo from "/logo.jpg"; 
import "./aOLSLMasset.css";
import { useTimer } from "../../../context/TimerContext"; 
import ErrorBoundary from "../../dev/utils/ErrorBoundary"; 

interface PublicImage {
  url: string;
  alt: string;
}
interface PublicImages {
  getImageById: (id: number) => PublicImage;
}
interface Firebase { 
  signInUser: (email: string, password: string) => Promise<any>;
  signOutUser: () => Promise<void>;
  auth: {
    currentUser?: {
      sendEmailVerification: () => Promise<void>;
    };
  };
}
interface AOLSLMassetProps {
  firebase: Firebase; 
}

const { Title, Text, Paragraph } = Typography;

// A new styled-component to ensure the white text color is applied
const StyledDescriptionText = styled(Text)`
  &.ant-typography {
    color: #ffffff; /* Sets color to pure white */
    font-size: 16px;
    text-align: left;
    white-space: pre-wrap;
    line-height: 1.8;
    flex: 1;
    min-width: 0;
  }
`;

const AOLSLMasset: React.FC<AOLSLMassetProps> = ({ firebase }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const renderCount = useRef(0);
  const isMounted = useRef(false);
  
  const { isSessionActive } = useTimer(); 

  const salesData = {
    assets: [
      { label: "379", value: "379", link: "/aOLSLMasset" },
      { label: "1.45", value: "1.45", link: "/aOLSLMasset" },
      { label: "346 - OLS9LM", value: "346", link: "/aOLSLMasset", percentage: "1.8 %" },
      { label: "33 - OLS4LM", value: "33", link: "/aOLSLMasset", percentage: "0.5 %" }, 
    ],
  };

  useEffect(() => {
    if (isMounted.current) {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    } else {
      isMounted.current = true;
    }
    renderCount.current += 1;
  }, []); 

  const handleCTAClick = useCallback(() => {
    navigate("/register/olslmregister");
  }, [navigate]);

  return (
    <ErrorBoundary>
      <div className={`wrapper full-height-layout ${isSessionActive ? "session-active" : ""}`}>
        <Helmet>
          <title>OLSLM Assets - OneLightSystem OLS</title>
          <meta
            name="description"
            content="Discover OLSLM assets, tokenized personal eternal equity from Sun Light Meditation, ushering in a global tokenization era with OneLightSystem OLS. Join OLS at olsme.com/OLSStudentPromise to explore your potential."
          />
          <meta
            name="keywords"
            content="OLSLM Assets, Sun Light Meditation, OLS Education, Light Civilization, Blockchain Assets, Join OLS, tokenized equity, meditative energy"
          />
          <link rel="canonical" href="https://www.olsme.com/aOLSLMasset" />
          <meta property="og:title" content="OLSLM Assets - Tokenized Eternal Equity with OneLightSystem OLS" />
          <meta property="og:description" content="Explore OLSLM, your personal eternal equity from Sun Light Meditation. Join the OLS global tokenization movement. Register at olsme.com/OLSStudentPromise." />
          <meta property="og:image" content={logo} /> 
          <meta property="og:url" content="https://www.olsme.com/aOLSLMasset" />
          <meta property="og:type" content="website" />
        </Helmet>
        <section className="content-section">
          <div className="content">
            <Link to="/login" aria-label="Go to Login Page">
              <img className="logo-image" src={logo} alt="OLSME Logo" />
            </Link>
            <Title level={2} style={{ color: "#ffaa00" }}>
              OneLightSystem OLSLM Available Assets
            </Title>
            <div className="button-row">
              <Button className="nav-button">
                <Link to="/lightScience">OneLightSystem</Link>
              </Button>
              <Button className="nav-button">
                <Link to="/OLSaeo">OLS iee.aeo</Link>
              </Button>
              <Button className="nav-button">
                <Link to="/OLSStudentPromise">Join OLS Student</Link>
              </Button>
              <Button className="nav-button">
                <Link to="/OLSLMprivacy">OLSLM Privacy</Link>
              </Button>
              <Button className="nav-button">
                <Link to="/olsme">OLSME</Link>
              </Button>
            </div>
            <div className="description-section">
              <StyledDescriptionText>
                OneLightSystem Light Minute (OLSLM)
                {"\n"}1 OLSLM = 1 OneLightSystem Light Minute
                {"\n"}A pioneering personal Light real equity asset, minned through
                OLS techniques that leverage an OLS student as an essential practitioner of a Sun Light Meditation
                developed by the OneLightSystem OLS.
                {"\n"}<strong><b>OLSLM assets are Assets and Benefits at the same time!</b></strong> <b>personal eternal equity</b> derived from the <b>"active" meditative Light energy</b> a <b>"Sun Light Meditation"</b> practices,
                 representing a <b>unique and real form of a value</b> in the OneLightSystem ecosystem and beyond.
                  {"\n"}Each OLSLM asset is mined through <b>active meditation techniques</b>, reflecting the user's commitment to <b>personal growth 
                 and OLS principles</b>. These assets are not just digital tokens; they embody the meditative <b>"Light" energy</b> and dedication of the OLS community, contributing to a <b>global tokenization era</b> where <b>personal equity is recognized and valued</b>.

                {"\n"}Join the future of a real value assets creation with OLSLM and enhance your journey with "Sun Light Meditation" practices.
              </StyledDescriptionText>
              <img
                className="asset-logo"
                src={publicImages.getImageById(12).url}
                alt={publicImages.getImageById(12).alt}
              />
            </div>
            <div className="assets-wrapper-section">
              <Title level={3} className="section-title">OLSLM Asset Availability</Title>
              <div className="assets-wrapper-container">
                <div className="assets-wrapper">
                  <div className="asset-header">
                    <a href={salesData.assets[0].link} className="asset-button">
                      {salesData.assets[0].value}
                    </a>
                    <Text strong style={{ fontSize: 20, color: "#ffa500" }}>available OLSLM Assets</Text>
                    <a href={salesData.assets[1].link} className="percentage-button">
                      {salesData.assets[1].value}
                    </a>
                  </div>
                  <hr className="separator-line" />
                  {salesData.assets.slice(2).map((asset, index) => (
                    <div key={index} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <a href={asset.link} className="metric-button">
                        {asset.value}
                      </a>
                      <a href={asset.link} className="action-button">
                        {asset.label.split(" - ")[1] || "Reserve"}
                      </a>
                      <a href={asset.link} className="percentage-button">
                        {asset.percentage}
                      </a>
                       <Button
              type="primary"
              onClick={handleCTAClick}
              className="cta-button"
            >
              Apply to Obtain OLSLM Assets
            </Button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="category-section">
              <StyledDescriptionText>
                <strong>OLSLM Categories Assets Value</strong>
                 {"\n"}These assets are categorized into distinct levels as a current availability (OLSLM, OLSL4M OLS9LM) based on their value and utility within the OneLightSystem ecosystem. Each category reflects the asset's potential for growth and
                its conditioning Leveled in decentralized value creation, providing users with a clear understanding of their investment in the "OLS meditation education".
              </StyledDescriptionText>
              <img
                className="category-image"
                src={publicImages.getImageById(6).url}
                alt={publicImages.getImageById(6).alt}
              />
            </div>
            <div className="marketplace-section">
              <img
                className="marketplace-image"
                src={publicImages.getImageById(3).url}
                alt={publicImages.getImageById(3).alt}
              />
              <StyledDescriptionText>
                <strong>OLSLM Marketplace</strong>
                {"\n"}To obtain OLSLM assets, register and verify yourself to gain access to the OLSLM Marketplace. Once verified, you can place an order to secure your ownership position and participate in the ecosystem's growth.
                {"\n"} <Button
              type="primary"
              onClick={handleCTAClick}
              className="cta-button"
            >
              Apply to Obtain OLSLM Assets
            </Button>
              </StyledDescriptionText>
            </div>
            <div className="transfer-section">
              <img
                className="transfer-image"
                src={publicImages.getImageById(4).url}
                alt={publicImages.getImageById(4).alt}
              />
              <StyledDescriptionText>
                <strong>OLSLM Assets Transfer</strong>
                {"\n"}Visually shown how OLSLM assets will transfer a unique asset from the OLSLM owner to the potential OLSLM assets receiver. The OLSLM asset is an additional layer that will benefit the owner if selected to use the assets, with potential minting a percentage from the original owner (learn more during ownership support).
              </StyledDescriptionText>
            </div>
            
            <Paragraph style={{ marginTop: '20px', color: '#ffcc00' }}>
              Begin your journey with OLS and explore unique "Sun Light Meditation" assets. 
              <Link to="/OLSStudentProspect" style={{ color: '#ffaa00', fontWeight: 'bold' }}> 
               {"\n"} Earn your own Assets 
               {"\n"}Join OLS Explore OLS student Prospect olsme.com/OLSStudentProspect today!</Link>
            </Paragraph>
            <Button
              type="primary"
              onClick={() => navigate("/OLSStudentProspect")}
              className="cta-button"
            >
              OLS student prospect
            </Button>
          </div>
        </section>
      </div>
    </ErrorBoundary>
  );
};

export default withFirebase(AOLSLMasset);